<main class="mat-body">
    <div class="bg-white">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-12 col-md-8 mt-5">
                    <h1 class="mat-display-2 text-blue text-center font-weight-bold">{{ 'contract.nature.title'|translate }}</h1>
                </div>
                <div class="col-12 col-md-6 mb-2">
                    <h2 class="mat-headline text-center font-weight-bold">{{ 'contract.nature.sub-title'|translate }}</h2>
                </div>
            </div>
        </div>
    </div>
    <div class="container">
        <thr-radio-group [(ngModel)]="natureValue">
            <div class="row mt-5 justify-content-center text-center">
                <div class="col-12 col-sm-6 col-md-4">
                    <thr-radio-button class="justify-content-center" [size]="160" [value]="Nature.NATURAL">
                        <i class="icon-natural"></i>
                    </thr-radio-button>
                    <label class="mat-headline text-blue" [innerHTML]="'contract.nature.natural'|translate"></label>
                </div>
                <div class="col-12 col-sm-6 col-md-4">
                    <thr-radio-button class="justify-content-center" [size]="160" [value]="Nature.COMPANY">
                        <i class="icon-legal"></i>
                    </thr-radio-button>
                    <label class="mat-headline text-blue" [innerHTML]="'contract.nature.legal'|translate"></label>
                </div>
            </div>
            <div class="row justify-content-center my-4">
                <div class="col-10 col-sm-6 col-md-4">
                    <button
                        type="button"
                        class="full-width mat-elevation-z0"
                        mat-raised-button
                        color="blue"
                        [disabled]="!natureValue"
                        (click)="onClick()"
                    >
                        {{ 'general.continue'|translate }}
                    </button>
                </div>
            </div>
        </thr-radio-group>
    </div>
</main>
